import * as amplitude from '@amplitude/analytics-browser'
import { AmplitudeBrowserClientOptions, DEFAULT_AMPLITUDE_OPTIONS, ProductArea, ProductCode } from '@pathccm/amplitude-browser'
import AmplitudePlugin from './amplitude-plugin'
import ReportingAdapter, { MarketingSiteSegmentTransition } from './reporting/reporting-adapter'
import { EventPrefix, Trigger } from '@pathccm/common-analytics/events'

import launchDarklyJsClient from './reporting/launchdarkly-js-client'

export const MARKETING_AMPLITUDE_OPTIONS: AmplitudeBrowserClientOptions = {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  apiKey: process.env.GATSBY_AMPLITUDE_API_KEY!,
  productCode: ProductCode.MARKETING_SITE,
  productArea: ProductArea.MARKETING_SITE,
  plugins: [new AmplitudePlugin()],
  options: DEFAULT_AMPLITUDE_OPTIONS
  // TODO: disable page views once data team is ready for MKTG_Site_PageLoad (page-router.tsx)
  // https://rula.slack.com/archives/C08LL6N3AAG/p1747081134829459
  // options: {
  //   ...DEFAULT_AMPLITUDE_OPTIONS,
  //   autocapture: {
  //     attribution: true,
  //     pageViews: false,
  //     sessions: true,
  //     // Deemed too noisy / less valuable to product for now
  //     formInteractions: false,
  //     fileDownloads: false,
  //     elementInteractions: false
  //   }
  // }
}

export const amplitudeAnalytics = (): void => {
  launchDarklyJsClient.on('ready', () => {
    // Capture Link Clicks
    window.addEventListener('click', (event: Event) => {
      let t

      if (event.target instanceof HTMLAnchorElement) {
        t = event.target
      } else if ((event.target as HTMLElement)?.parentElement instanceof HTMLAnchorElement) {
        if (event.target === null) return

        // Some instances we wrap buttons in a tags
        t = (event.target as HTMLElement).parentElement
      } else {
        return
      }

      const marketingSiteSegmentTransition = launchDarklyJsClient.variation('marketing-site-segment-transition', 'amplitude') as MarketingSiteSegmentTransition
      const reporting = new ReportingAdapter(marketingSiteSegmentTransition)

      const payload = {
        href: t.href,
        text: t.text,
        id: t.id,
        hash: t.hash,
        hostname: t.hostname,
        className: t.className
      }

      if (t.hostname !== window.location.hostname) {
        amplitude.setTransport('beacon')

        reporting.trackLink(event, t.href, {
          eventName: {
            prefix: EventPrefix.MARKETING_SITE,
            trigger: Trigger.OUTBOUND_LINK_CLICKED
          },
          properties: {
            ...payload,
            trigger: Trigger.OUTBOUND_LINK_CLICKED
          }
        })

        amplitude.flush()
      } else if (t.hash !== undefined && t.hash !== '') {
        reporting.track({
          eventName: {
            prefix: EventPrefix.MARKETING_SITE,
            trigger: Trigger.ANCHOR_LINK_CLICKED
          },
          properties: {
            ...payload,
            trigger: Trigger.ANCHOR_LINK_CLICKED
          }
        })
      } else {
        reporting.track({
          eventName: {
            prefix: EventPrefix.MARKETING_SITE,
            trigger: Trigger.INTERNAL_LINK_CLICKED
          },
          properties: {
            ...payload,
            trigger: Trigger.INTERNAL_LINK_CLICKED
          }
        })
      }
    })

    window.addEventListener('pagehide', () => {
      amplitude.setTransport('beacon')
      amplitude.flush()
    })
  })
}
